export default __webpack_public_path__ + "static/media/sen.e0200d4c.svg";